export function hasAccessToPremiumFeatures(userData) {
  if (!userData) return false;
  
  if (userData.main_group?.name === 'creator') {
    return true;
  }
  
  return userData.current_plan?.name !== 'Free';
}

export function isWhitelabelUser(userData) {
  return userData?.main_group?.name === 'whitelabel';
}

export function isBrand(userData) {
  return userData?.main_group?.name !== 'creator';
}

export function isSuperUser(userData) {
  return userData?.is_superuser === true;
}